export default __webpack_public_path__ + "static/media/Debug_JS_Errors_-_adamr.space___Codecademy.3380f676.pdf";